import { PlatformImageType, PlatformMaterialType } from '../types/common.types';
import textilegenesis from '../images/textilegenesis.png';
import bettercotton from '../images/bettercotton.png';

export const Platforms: string[] = ['Textile Genesis', 'Better Cotton'];

export const PlatformIcon: PlatformImageType[] = [
	{
		platform: 'Textile Genesis',
		image: (
			<a href="https://live.textilegenesis.com/" target="_blank" rel="noopener noreferrer">
				<img src={textilegenesis} alt="Textile Genesis Logo" />
			</a>
		),
	},
	{
		platform: 'Better Cotton',
		image: (
			<a href="https://cottonplatform.bettercotton.org/" target="_blank" rel="noopener noreferrer">
				<img src={bettercotton} alt="Better Cotton Logo" />
			</a>
		),
	},
];

export const PlatformMaterials: PlatformMaterialType[] = [
	{
		materialId: '0193',
		platform: 'Better Cotton',
	},
	{
		materialId: '0248',
		platform: 'Better Cotton',
	},
	{
		materialId: '0083',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0059',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0308',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0316',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0321',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0372',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0383',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0384',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0180',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0407',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0772',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0803',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0831',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0016',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0037',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0026',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0312',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0436',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0787',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0788',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0789',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0813',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0815',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0031',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0870',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0873',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0875',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0876',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0877',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0878',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0879',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0880',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0811',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0854',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0855',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0792',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2014',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2020',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0891',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2011',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2007',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2006',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2022',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2013',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2010',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0323',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0412',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0416',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0421',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0730',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0790',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2026',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2039',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2040',
		platform: 'Textile Genesis',
	},
	{
		materialId: '0380',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2064',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2065',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2055',
		platform: 'Better Cotton',
	},
	{
		materialId: '2115',
		platform: 'Better Cotton',
	},
	{
		materialId: '2124',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2049',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2050',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2043',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2139',
		platform: 'Better Cotton',
	},
	{
		materialId: '2155',
		platform: 'Better Cotton',
	},
	{
		materialId: '2155',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2138',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2173',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2164',
		platform: 'Textile Genesis',
	},
	{
		materialId: '2175',
		platform: 'Textile Genesis',
	},
];
